<div class="custom-slider" [ngClass]="{ 'tick-white': isTickWhite }">
  <ng5-slider *appRenderOnlyInBrowser [(value)]="range" [options]="sliderOptions"></ng5-slider>
</div>
